import React from 'react';

import { withRouter } from 'react-router-dom';
import Suspense from '../../Common/components/Suspense-component';

import { getFreeUsersForCompanyOwner } from '../../Users/epics-users';
import { getSingleCompany } from '../epics-companies';
import EditCompany from '../component-edit-company';

class EditCompanyPage extends React.Component {
    getCompanyDetails = () => {
        const url = this.props.location.pathname;
        let companyId = url.split('/').pop();

        return getSingleCompany(companyId);
    };

    getUsersForCompanyOwners = (identifier, companyId) => {
        return getFreeUsersForCompanyOwner(identifier, companyId)
    };

    render() {
        return (
            <Suspense apiCalls={{
                selectedCompany: this.getCompanyDetails,
                companyOwnerList: this.getUsersForCompanyOwners
            }}>
                <EditCompany />
            </Suspense>
        );
    }
}

export default withRouter(EditCompanyPage);



// WEBPACK FOOTER //
// ./src/customModules/Companies/containers/container-edit-company.js